import React, { Component } from 'react';
import { Form } from 'react-form';
import Popup from '../../Popup';
import { Input, PhoneNumber } from '../../Form';
import { required } from '../../../utils/validation';
import { SupportLink } from '../../Links';
import styles from './addSchoolPopup.scss';

class AddSchoolPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitting: false,
            submitSuccessful: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
            submitSuccessful: false,
            updateError: false,
        });

        try {
            this.props.addHighSchool(values);
            console.log('handleSubmit success');
            this.setState({
                submitting: false,
                submitSuccessful: true,
            });
        } catch (error) {
            console.log('handleSubmit error');
            this.setState({
                submitting: false,
                updateError: true,
            });
        }
    }

    render() {
        const {
            defaultValues,
            onCloseClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md clear-over-flow`}
                popUpClassName={`${styles.editDualMatchEventPopup}`}
                popUpContentWrapperClassName={`${styles.editDualMatchPopupContent}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: false,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: true,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4 data-testid="modal.add-school.h4-64">Add New School</h4>
                </div>
                <div className={`${styles.section} pt0 pb24`}>
                    <Form onSubmit={values => this.handleSubmit(values)} id="addNewSchoolForm" defaultValues={defaultValues}>
                        {(formApi) => {
                            const { submitForm, errors /* , values, removeValue, addValue,  setValue, reset */ } = formApi;
                            return (
                                <form onSubmit={submitForm} id="addNewSchool" data-testid="modal.add-school.form-71">
                                    {!this.state.submitSuccessful && (
                                        <React.Fragment>
                                            <div className="row mb16">
                                                <div className={`col-12 mb24`}>
                                                    <Input
                                                        label="Coach Name"
                                                        id="name"
                                                        field="name"
                                                        // placeholder="Ex. Men's Singles"
                                                        validate={required}
                                                        data-testid="modal.add-school.name-input"
                                                    />
                                                    <Input
                                                        label="Coach Email"
                                                        id="formEmail"
                                                        field="formEmail"
                                                        // placeholder="Ex. Men's Singles"
                                                        validate={required}
                                                            data-testid="modal.add-school.form-email-input"
                                                    />
                                                    <PhoneNumber
                                                        label="Phone Number"
                                                        description=""
                                                        id="phoneNumber"
                                                        field="phoneNumber"
                                                        placeholder=""
                                                        validate={required}
                                                    />
                                                    <Input
                                                        label="School Name"
                                                        id="schoolName"
                                                        field="schoolName"
                                                        // placeholder="Ex. Men's Singles"
                                                        validate={required}
                                                            data-testid="modal.add-school.school-name-input"
                                                    />
                                                    <Input
                                                        label="School Address"
                                                        id="address"
                                                        field="address"
                                                        // placeholder="Ex. Men's Singles"
                                                        validate={required}
                                                        data-testid="modal.add-school.address-input"
                                                    />
                                                    <Input
                                                        label="Comments (Optional)"
                                                        id="comments"
                                                        field="comments"
                                                        data-testid="addschoolpopup.comments-input"
                                                    />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row mb32">
                                            <div className="col-12">
                                                Thank you, your request has been submitted. We will be in touch within 24 hours.
                                            </div>
                                        </div>
                                    )}
                                    {(errors || this.state.updateError) && (
                                        <hr
                                        data-testid="modal.add-school.comments-input"
                                        />
                                    )}
                                    {errors && (
                                        <div className="pb24 text-center text-error text-small" data-testid="modal.add-school.div-142">Both school name and address are required fields.</div>
                                    )}
                                    {this.state.updateError && (
                                        <div className="pb24 text-center text-error text-small" data-testid="modal.add-school.div-145">
                                            An error occurred while submitting this form. If this problem persists, please contact our <SupportLink target="_blank">support team.</SupportLink>
                                        </div>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                    data-testid="modal.add-school.got-it-btn"
                                                >
                                                    Got it
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                    data-testid="modal.add-school.cancel-btn"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={this.state.submitting}
                                                    data-testid="modal.add-school.submit-btn"
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            );
                        }}
                    </Form>
                </div>
            </Popup>
        );
    }
}

export default AddSchoolPopup;
